import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { ShippingController } from "./shipping-controller";
import { ShippingPage } from "./shipping-page";

export function ShippingRoute({ deps }: { deps: AppDeps }) {
  return (
    <Subtree
      key="shipping"
      controller={() => new ShippingController(pick(deps, "client", "authHandler", "storeRepository"))}
    >
      <ShippingPage />
    </Subtree>
  );
}
